<template>
  <div :class="flowEdit ? 'modal-container-edit' : ''">
    <div class="block" style="margin-top: 20px">
      <vxe-form
          ref="xForm1"
          class="my-form"
          title-align="right"
          :data="formData"
          :rules="formData.contractType === 414002748 ? formRules1 : formRules"
          title-width="100"
          prevent-submit>
        <vxe-form-item title="签约方式" field="signType" span="24">
          <template>
            <RadioGroup class="radioGroup" v-model="formData.signType" @on-change="changeRadio">
              <Radio :label="1">单方签署<span style="color:#BBBBBB;font-size: 12px;">(适用于申请平台单方盖章)</span></Radio>
              <Radio :label="2" style="margin-left: 20px;">双方签署</Radio>
              <Radio :label="3" style="margin-left: 20px;">多方签署</Radio>
            </RadioGroup>
          </template>
        </vxe-form-item>
        <vxe-form-item title="签约方" field="partyType" span="24">
          <template>
            <div class="add-group">
              <div class="cell" @click="addCell(1)" style="cursor: pointer">
                <img src="~assets/images/common/contract-add.png"/>
                <span>添加平台企业</span>
              </div>
              <div class="cell" @click="addCell(2)" style="margin-left: 29px;cursor: pointer">
                <img src="~assets/images/common/contract-add.png"/>
                <span>添加非平台企业</span>
              </div>
              <div class="cell" @click="addCell(3)" style="margin-left: 29px;cursor: pointer">
                <img src="~assets/images/common/contract-add.png"/>
                <span>添加个人</span>
              </div>
            </div>
          </template>
        </vxe-form-item>
        <vxe-form-item title=" " span="24" v-show="ordContractFadadaExpands.length > 0">
          <template>
            <div v-for="(item,index) in ordContractFadadaExpands" :key="index">
              <div class="add-block" style="padding: 20px 0;margin-top: 10px">
                <div class="receive"><span>签约方{{ ordContractFadadaExpands.length > 1 ? index + 1 : '' }}</span></div>
                <img @click="closeCell(index)" src="~assets/images/common/contract-close.png"/>
                <div v-if="item.partyType === 1">
                  <vxe-form-item title="平台企业名称" field="firstPartyName" title-width="120" span="12">
                    <template>
                      <div class="input-border" style="display: flex;align-items: center;">
                        <platform-corp
                            class="corp"
                            :isFadadaAuth="1"
                            :row="item"
                            :field="'partyName'"
                            :placeholder="'请选择平台企业'"
                            @select="(bool, index, row) => selectComp(bool, index, row,item)"
                        ></platform-corp>
                      </div>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="印章类型" field="signatureType" span="12">
                    <template>
                      <vxe-select v-model="item.signatureType" :options="item.signatureTypeOption"
                                  placeholder="请选择平台印章" @change="(file) =>checkComp(file,item)"></vxe-select>
                    </template>
                  </vxe-form-item>
                </div>
                <div v-if="item.partyType === 2">
                  <vxe-form-item title="企业名称" field="partyName" span="12">
                    <template>
                      <vxe-pulldown :ref="'compDown' + index" transfer>
                        <template v-slot>
                          <vxe-input v-model="item.partyName" placeholder="请输入企业名称"
                                     @input="(file) =>inputEvent(file,'compDown' + index)"
                                     style="width: 200px"></vxe-input>
                        </template>
                        <template v-slot:dropdown>
                          <div class="chainId-dropdown">
                            <vxe-grid
                                border="none"
                                highlight-hover-row
                                auto-resize
                                height="auto"
                                :loading="compLoading"
                                :data="tableData"
                                :columns="columns"
                                @cell-click="(file) => cellClick(file,item,'compDown' + index)"
                            ></vxe-grid>
                          </div>
                        </template>
                      </vxe-pulldown>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="手机号" field="partyPhone" span="12">
                    <template>
                      <vxe-input v-model="item.partyPhone" placeholder="请输入绑定手机号" style="width: 200px"></vxe-input>
                    </template>
                  </vxe-form-item>
                </div>
                <div v-if="item.partyType === 3">
                  <vxe-form-item title="个人姓名" field="partyName" span="12">
                    <template>
                      <vxe-input v-model="item.partyName" placeholder="请输入个人姓名" style="width: 200px"
                                 @input="signPlaceData = null;">
                        <template v-slot:suffix>
                          <img @click="chooseHisAddr(index)" src="~assets/images/common/addressBook.png"
                               style="margin-top: 5px;cursor: pointer"/>
                        </template>
                      </vxe-input>
                    </template>
                  </vxe-form-item>
                  <vxe-form-item title="手机号" field="partyPhone" span="12">
                    <template>
                      <vxe-input v-model="item.partyPhone" placeholder="请输入绑定手机号" style="width: 200px"></vxe-input>
                    </template>
                  </vxe-form-item>
                </div>
              </div>
            </div>
          </template>
        </vxe-form-item>
        <vxe-form-item title="合同编号" field="contractNum" span="8">
          <template v-slot="scope">
            <vxe-input v-model="formData.contractNum" placeholder="请输入合同编号" :disabled="flowEdit" clearable
                       @input="$refs.xForm1.updateStatus(scope)" style="width: 300px;" @blur="checkValue"></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item title="合同类型" field="contractType" span="8">
          <template v-slot>
            <vxe-select v-model="formData.contractType" :options="valueType" style="width: 300px"
                        @change="change"
                        placeholder="请选择合同类型"></vxe-select>
          </template>
        </vxe-form-item>
        <vxe-form-item title="合同有效期" field="passTime" span="8">
          <template v-slot="scope">
            <vxe-input type="date" v-model="formData.passTime"
                       placeholder="选填" @input="$refs.xForm1.updateStatus(scope)" style="width:300px" clearable></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item title="合同名称" field="contractName" span="8">
          <template v-slot="scope">
            <vxe-input v-model="formData.contractName" placeholder="请输入合同名称" clearable
                       @input="$refs.xForm1.updateStatus(scope)" style="width: 300px;"></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item title="业务员" field="salesMan" span="8">
          <template>
            <div v-if="!isSaleMan" :class="salesManCheck ? 'input-border border-red' : 'input-border'"
                 style="display: flex;align-items: center;">
              <sales-man
                  :row="formData"
                  :field="'salesMan'"
                  :placeholder="'请选择业务员'"
                  @setSaleMan="setSaleMan"
                  @focus="clearTableV"
                  @blur="clearTableV"
              ></sales-man>
            </div>
            <vxe-input v-else v-model="formData.salesMan" disabled style="width: 300px;"></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item title="骑缝章" field="isAcrosspage" span="8">
          <template>
            <RadioGroup class="radioGroup" v-model="formData.isAcrosspage">
              <Radio :label="1">是</Radio>
              <Radio :label="0" style="margin-left: 20px;">否</Radio>
            </RadioGroup>
          </template>
        </vxe-form-item>
        <vxe-form-item title="合同文件" field="docUrl" span="8">
          <div v-show="formData.docUrl" class="input-border" style="display: flex;align-items: center;">
            <img style="height: 42px;width: 42px;" src="~assets/images/common/upload-icon.png"/>
            <span
                style="font-size: 14px;font-family: Microsoft YaHei,sans-serif;font-weight: 400;color: #1A8CFE;white-space:nowrap; overflow:hidden; text-overflow:ellipsis; ">{{
                formData.docName
              }}</span>
            <img style="height: 10px;width: 10px;" src="~assets/images/common/close.png" @click="handleRemove"/>
          </div>
          <Upload
              v-show="!formData.docUrl"
              :max-size="10240"
              style="width: 300px;"
              ref="upload"
              :show-upload-list="false"
              :default-file-list="defaultList"
              :before-upload="handleUpload"
              :on-exceeded-size="handleMaxSize"
              :on-success="loadfile"
              :action="actionUrl"
              :headers="uploadHeaders"
              accept=".pdf,.doc,.docx,.png,.jpg,.jpeg,.bmp">
            <div>
              <div class="attach" style="cursor: pointer">
                <img style="width: 12px;height: 13px;margin-left: 21px" src="~assets/images/common/upload.png"/>
                <span>上传合同文件</span>
                <i class="vxe-icon--question" style="margin-left: 5px;cursor: pointer;"
                   title="文件格式支持pdf,doc,docx,png,jpg,jpeg,bmp"></i>
              </div>
            </div>
          </Upload>
        </vxe-form-item>
        <vxe-form-item title="签署位置" field="signPlaceData" span="8">
          <template>
            <div class="signPlace" @click="setSignPlace">
              <img src="~assets/images/common/hqyz.png"/>
              <span>{{ signPlaceData ? '已设置签约方签署位置' : '设置签约方签署位置' }}</span>
            </div>
          </template>
        </vxe-form-item>
      </vxe-form>
    </div>
    <div class="block" style="margin-top: 20px" v-if="formData.contractType === 41400618">
      <vxe-form
          ref="xForm2"
          class="my-form"
          title-align="right"
          :data="formData"
          title-width="100"
          prevent-submit>
        <vxe-form-item title="车船号" field="carShipNum" span="8">
          <template v-slot="scope">
            <vxe-input v-model="formData.carShipNum" placeholder="请输入车船号" clearable
                       @input="$refs.xForm2.updateStatus(scope)" style="width: 300px;"></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item title="货名" field="goodsName" span="8">
          <template v-slot="scope">
            <vxe-input v-model="formData.goodsName" placeholder="请输入货名" clearable
                       @input="$refs.xForm2.updateStatus(scope)" style="width: 300px;"></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item title="起运日期" field="beginTime" span="8">
          <template v-slot="scope">
            <vxe-input v-model="formData.beginTime" type="date" placeholder="请选择起运日期" clearable
                       @input="$refs.xForm2.updateStatus(scope)" style="width: 300px;"></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item title="起运地" field="beginPlace" span="8">
          <template v-slot="scope">
            <vxe-input v-model="formData.beginPlace" placeholder="请输入起运地" clearable
                       @input="$refs.xForm2.updateStatus(scope)" style="width: 300px;"></vxe-input>
          </template>
        </vxe-form-item>
        <vxe-form-item title="到达地" field="endPlace" span="8">
          <template v-slot="scope">
            <vxe-input v-model="formData.endPlace" placeholder="请输入到达地" clearable
                       @input="$refs.xForm2.updateStatus(scope)" style="width: 300px;"></vxe-input>
          </template>
        </vxe-form-item>
      </vxe-form>
    </div>
    <div class="footer add-btn-box" v-if="flowEdit">
      <Button @click="cancel" style="border-radius: 4px;">取 消</Button>
      <Button type="primary" @click="commit" style="border-radius: 4px;">确 定</Button>
    </div>
    <vxe-modal v-model="signPlaceModal" title="获取签约位置" width="1400" height="900" position="center" destroy-on-close>
      <sign-place ref="signPlace" @setSign="setSign" @close="signPlaceModal = false"></sign-place>
    </vxe-modal>
    <vxe-modal class="historyModal" v-model="historyModal" title="选择个人客户" width="800" height="600" position="center"
               destroy-on-close>
      <choose-his-addr-book ref="historyModal" @choose="setPerson"></choose-his-addr-book>
    </vxe-modal>
  </div>
</template>
<script>
import PlatformCorp from "@/components/common/PlatformCorp";
import ChooseHisAddrBook from "@/components/contract/ChooseHisAddrBook";
import auth from "@/utils/auth";
import {hideLoading, isEmpty, showLoading} from "@/utils/util";
import $api from "@/apiProvider";
import Auth from "@/utils/auth";
import SalesMan from "@/components/common/SalesMan";
import SignPlace from "@/views/contracts/SignPlace";

const PDFJS = require('pdfjs-dist');

export default {
  name: "CreateEleModal",
  props: {
    isSubmit: {
      type: Boolean,
      default: false
    },
    isCancel: {
      type: Boolean,
      default: false
    },
    isSave: {
      type: Boolean,
      default: false
    },
    flowEdit: {
      type: Boolean,
      default: false
    },
  },
  components: {PlatformCorp, SalesMan, SignPlace, ChooseHisAddrBook},
  data() {
    let userInfoValue = {};
    if (Auth.isLogin()) {
      userInfoValue = Auth.getAuth();
    }
    return {
      userInfoValue,
      signPlaceModal: false,
      isShowChooseAccount: false,
      currentChoose: '',
      isInit: false,
      actionUrl: "",
      defaultList: [],
      uploadHeaders: {
        Authorization: auth.getAuth().token,
        token: auth.getAuth().token,
      },
      ordContractFadadaExpands: [],
      formData: {
        passTime: null,
        carShipId: null,
        carShipNum: null,
        carShipType: null,
        compName: null,
        contractName: null,
        contractNum: null,
        contractType: 41400618,
        docName: null,
        docUrl: null,
        firstPartyId: null,
        firstPartyName: null,
        firstPartyPhone: null,
        firstPartyType: null,
        beginTime: null,
        beginPlace: null,
        endPlace: null,
        goodsName: null,
        platformCompanyId: null,
        salesMan: null,
        salesManId: null,
        secondPartyId: null,
        secondPartyName: null,
        secondPartyPhone: null,
        secondPartyType: null,
        signType: null,
        isAcrosspage: 1,
        signPageNum: 1,
        signPositionsX: 0,
        signPositionsY: 0
      },
      valueType: [],
      type: 0,
      selectTab: "tab1",
      loading: false,
      companyData: [],
      personalData: [],
      username: null,
      formRules: {
        contractName: [{required: true, message: "请输入合同名称"},
          {max: 30, message: "合同名称长度不超过30个字符"}],
        contractType: [{required: true, message: "请选择合同类型"}],
        signType: [{required: true, message: "请选择签约方式"}],
        docUrl: [{required: true, message: "请上传合同"}],
        salesMan: [{required: true, message: "请选择业务员"}],
        carShipNum: [{required: true, message: "请输入车船号"}],
        goodsName: [{required: true, message: "请输入货名"}],
        beginTime: [{required: true, message: "请选择起运日期"}],
        beginPlace: [{required: true, message: "请输入起运地"}],
        endPlace: [{required: true, message: "请输入目的地"}],
        signPlaceData: [{required: true, message: "请设置签署位置"}],
      },
      formRules1: {
        contractName: [{required: true, message: "请输入合同名称"},
          {max: 30, message: "合同名称长度不超过30个字符"}],
        contractType: [{required: true, message: "请选择合同类型"}],
        signType: [{required: true, message: "请选择签约方式"}],
        docUrl: [{required: true, message: "请上传合同"}],
        carShipNum: [{required: true, message: "请输入车船号"}],
        goodsName: [{required: true, message: "请输入货名"}],
        beginTime: [{required: true, message: "请选择起运日期"}],
        beginPlace: [{required: true, message: "请输入起运地"}],
        endPlace: [{required: true, message: "请输入目的地"}],
        signPlaceData: [{required: true, message: "请设置签署位置"}],
      },
      formRules2: {
        contractName: [{required: true, message: "请输入合同名称"},
          {max: 30, message: "合同名称长度不超过30个字符"}],
        contractType: [{required: true, message: "请选择合同类型"}],
        signType: [{required: true, message: "请选择签约方式"}],
        docUrl: [{required: true, message: "请上传合同"}],
        salesMan: [{required: true, message: "请选择业务员"}],
        signPlaceData: [{required: true, message: "请设置签署位置"}],
      },
      block1: false,
      block2: false,
      isSaleMan: false,
      searchLoading: false,
      secondPartyNameOptions: [],
      firstPartyCheck: false,
      salesManCheck: false,
      tableData: [],
      columns: [{field: "compName", title: "企业名称"}, {field: "regisiterNum", title: "手机号"}], // 选择平台企业下拉框数据列
      compLoading: false,
      curIndex: null,
      historyModal: false,
      signPlaceData: null
    };
  },
  mounted() {
    this.actionUrl = process.env.VUE_APP_API + "/api/tool/oss/upload";
  },
  watch: {
    isSubmit(val) {
      if (val) {
        this.check();
      }
    },
    isCancel(val) {
      if (val) {
        this.reset();
      }
    },
    isSave(val) {
      if (val) {
        this.setParams();
      }
    }
  },
  methods: {
    checkComp(value, item) {
      if (!item.partyName) {
        this.$XModal.alert({
          message: '请先选择平台企业',
          status: "error",
        });
        item.signatureType = null;
        return
      }
      item.signatureType = value.value;
    },
    setPerson(row) {
      this.signPlaceData = null;
      this.ordContractFadadaExpands[this.curIndex].partyId = row.partyId;
      this.ordContractFadadaExpands[this.curIndex].partyName = row.partyName;
      this.ordContractFadadaExpands[this.curIndex].partyPhone = row.partyPhone;
      this.historyModal = false;
    },
    chooseHisAddr(index) {
      this.curIndex = index;
      this.historyModal = true;
      this.$nextTick(() => {
        this.$refs.historyModal.init();
      })
    },
    setSignPlace() {
      if (!this.formData.docUrl) {
        this.$XModal.alert({
          message: '请先上传合同文件',
          status: "error",
        });
        return
      }

      if (!this.formData.signType) {
        this.$XModal.alert({
          message: '请选择签约方式',
          status: "error",
        });
        return
      }

      if ((this.formData.signType === 1 && this.ordContractFadadaExpands.length !== 1)
          || (this.formData.signType === 2 && this.ordContractFadadaExpands.length !== 2)
          || (this.formData.signType === 3 && this.ordContractFadadaExpands.length < 3)) {
        this.$XModal.alert({
          message: '请添加正确的签约方',
          status: "error",
        });
        return
      }

      let checkPartyName = false;
      this.ordContractFadadaExpands.map(i => {
        if (!i.partyName) {
          checkPartyName = true;
          return
        }
      })

      if (checkPartyName) {
        this.$XModal.alert({
          message: '请完善签约方信息',
          status: "error",
        });
        return
      }

      this.signPlaceModal = true;
      this.$nextTick(() => {
        this.$refs.signPlace.setPdfArea(this.formData.docUrl);
        this.$refs.signPlace.initSignData(this.signPlaceData, this.ordContractFadadaExpands, this.formData.signType)
      })
    },
    setSign(data) {
      this.signPlaceData = data;
      this.signPlaceModal = false;
      this.clearTableV();
    },
    checkValue() {
      if (this.formData.contractNum && this.formData.contractNum.substring(0, 2) === 'NH') {
        this.$XModal.alert({
          message: '合同编号格式错误',
          status: "error",
        });
        this.formData.contractNum = null;
        return
      }
    },
    commit() {
      this.$emit('update');
    },
    cancel() {
      this.$emit('close');
    },
    async check() {
      this.formData.signPlaceData = this.signPlaceData;
      let sts = await this.validEvent();
      if (!sts) {
        this.$emit("setParams", false);
        return;
      }
      this.setParams();
    },
    setParams() {
      let that = this;
      let obj = Object.assign({}, this.formData);
      if (obj.beginTime) {
        obj.beginTime = this.$utils.timestamp(obj.beginTime);
      }
      if (obj.passTime) {
        obj.passTime = this.$utils.timestamp(obj.passTime);
      }
      if (obj.signPageNum) {
        obj.signPageNum = obj.signPageNum - 1;
      }
      obj.ordContractFadadaExpands = this.ordContractFadadaExpands;
      obj.signPlaceData = this.signPlaceData;
      if (obj.ordContractFadadaExpands.length > 0) {
        if (that.signPlaceData) {
          obj.ordContractFadadaExpands.map(i => {
            let signaturePositions = [];
            for (let key in that.signPlaceData) {
              for (let val in that.signPlaceData[key]) {
                let j = that.signPlaceData[key][val];
                if (i.partyName === j.name) {
                  signaturePositions.push({
                    pagenum: key - 1,
                    x: (j.left + j.width / 2) / 595 * 800,
                    y: (j.top + j.height / 2) / 842 * 1131,
                    top: j.top,
                    left: j.left,
                    width: j.width,
                    height: j.height,
                    sealUrl: j.sealUrl,
                    index: j.index,
                    name: j.name,
                    type: j.type,
                  })
                  i.signaturePositions = JSON.stringify(signaturePositions);
                }
              }
            }
          })
        }
      }

      // 过滤参数
      this.$emit("setParams", obj);
    },
    inputEvent(val, name) {
      if (val && val !== '') {
        this.$nextTick(() => {
          this.$refs[name][0].showPanel();
          this.queryUserList(val);
          this.signPlaceData = null;
        })
      }
    },
    cellClick({row}, item, name) {
      item.partyName = row.compName;
      item.partyPhone = row.regisiterNum;
      this.$refs[name][0].hidePanel();
    },
    async queryUserList(val) {
      this.compLoading = true;
      let res = await $api.baseUserSign.post("queryUserList", {
        page: 1,
        rows: 1000,
        username: val,
        userType: 2
      });
      this.compLoading = false;
      if (res.status === 1) {
        this.tableData = res.data.rows;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async getDictByCode(code, key) {
      let res = await $api.dict.get("searchDic", {
        parentcode: code
      });
      if (res.status === 1) {
        let arr = [];
        let data = res.data;
        data.map(i => {
          arr.push({
            label: i.dictText,
            value: i.dictCode,
          })
        })
        this[key] = arr;
      } else {
        this.$XModal.message(res.message);
      }
    },
    init() {
      this.reset();
      if (this.userInfoValue.identityType === 0) {
        this.isSaleMan = true;
        this.formData.salesMan = this.userInfoValue.name;
        this.formData.salesManId = this.userInfoValue.id;
      } else {
        this.isSaleMan = false;
      }
      this.getDictByCode(41400, 'valueType');
    },
    clearTableV() {
      this.$refs.xForm1.clearValidate();
      if (this.$refs.xForm2) {
        this.$refs.xForm2.clearValidate();
      }
      this.salesManCheck = false;
    },
    setSaleMan(val) {
      this.clearTableV();
    },
    addCell(type) {
      if (!this.formData.signType) {
        this.$XModal.alert({
          message: '请先选择签约方式',
          status: "error",
        });
        return
      }
      if (this.formData.signType === 1) {
        if (this.ordContractFadadaExpands.length >= 1) {
          this.$XModal.alert({
            message: '单方签署仅可添加一个签约方',
            status: "error",
          });
          return
        }
      } else if (this.formData.signType === 2) {
        if (this.ordContractFadadaExpands.length >= 2) {
          this.$XModal.alert({
            message: '双方签署仅可添加两个签约方',
            status: "error",
          });
          return
        }
      }
      if (type === 1) {
        this.ordContractFadadaExpands.push({
          partyId: null,
          partyName: null,
          partyPhone: null,
          signaturePositions: null,
          partyType: type,
          signatureType: null,
          signatureTypeOption: [],
        })
      } else {
        this.ordContractFadadaExpands.push({
          partyId: null,
          partyName: null,
          partyPhone: null,
          signaturePositions: null,
          partyType: type
        })
      }
    },
    closeCell(index) {
      this.ordContractFadadaExpands.splice(index, 1);
    },
    changeRadio(e) {
      this.ordContractFadadaExpands = [];
      this.signPlaceData = null;
      this.clearTableV();
    },
    change() {
      this.clearTableV();
    },
    async validEvent() {
      let errMap = await this.$refs.xForm1
          .validate()
          .catch((errMap) => errMap);

      if (this.formData.contractType !== 414002748) {
        if (!this.formData.salesMan || this.formData.salesMan === '') {
          this.salesManCheck = true;
        }
      }
      return errMap ? false : true;
    },
    async saveDraftFlowForContractFadada() {
      this.isSubmit = true;
      showLoading();
      let obj = Object.assign({}, this.formData);
      obj.beginTime = this.$utils.timestamp(obj.beginTime);
      obj.signType = obj.signType === 3 ? 1 : obj.signType;
      let res = await $api.flowInstance.request("saveDraftFlowForContractFadada", {
        applyTime: this.$utils.timestamp(this.$utils.toStringDate(this.proData.applyTime)),
        applyUserId: this.proData.applyUserId,
        contractFadada: obj,
        flowTempletId: 11,
        id: this.initBySaveId ? this.initBySaveId : null,
        instanceName: this.proData.instanceName,
        instanceNum: this.proData.instanceNum,
        leaderId: this.proData.leaderId,
        managerId: this.proData.managerId,
        reterenceId: this.proData.reterenceId,
      });
      hideLoading();
      if (res.status === 1) {
        this.$Message.success("提交成功");
        this.close();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async initBySave(id) {
      this.isInitBySave = true;
      this.initBySaveId = id;
      $api.flowInstance.queryDraftFlowDetail
          .GET({
            params: {
              id
            }
          })
          .then(res => {
            if (res.status === 1) {
              this.proData = Object.assign({}, res.data);
              this.isLoaded = true;
              this.getContractFadadaTwoList(id);
            } else {
              this.$XModal.alert({
                message: res.message ? res.message : "接口异常",
                status: "error"
              });
            }
          });
    },
    async getContractFadadaTwoList(id, type) {
      this.getDictByCode(41400, 'valueType');
      let res = await $api.eleContract.request("getContractFadadaTwoList", {
        flowId: id
      });
      if (res.status === 1) {
        if (res.data.rows.length > 0) {
          let data = res.data.rows[0];
          this.setData(data, type);
        }
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async setData(data, type) {
      let self = this;
      if (data.beginTime) {
        data.beginTime = this.$utils.toStringDate(data.beginTime);
      }
      if (data.passTime) {
        data.passTime = this.$utils.toStringDate(data.passTime);
      }
      this.signPlaceData = {};

      let indexArr = [];
      if (data.ordContractFadadaExpands) {
        data.ordContractFadadaExpands.map(i => {
          if (i.signaturePositions) {
            let signaturePositions = JSON.parse(i.signaturePositions);
            signaturePositions.map(j => {
              indexArr.push(j.pagenum);
            })
          }
        })
        let newArr = [...new Set(indexArr)];
        newArr.map(pageNum => {
          let sign = {};
          let index = 0;
          data.ordContractFadadaExpands.map(i => {
            let signaturePositions = JSON.parse(i.signaturePositions);
            signaturePositions.map(j => {
              if (j.pagenum === pageNum) {
                sign[index] = {
                  width: j.width,
                  height: j.height,
                  top: j.top,
                  left: j.left,
                  pageNum: j.pagenum + 1,
                  sealUrl: j.sealUrl,
                  index: j.index,
                  name: j.name,
                  type: j.type,
                };
                index++;
              }
            })
          })
          this.signPlaceData[pageNum + 1] = sign;
        })
      }

      for (let i in data.ordContractFadadaExpands) {
        let item = data.ordContractFadadaExpands[i];
        if (item.partyType === 1) {
          let res = await self.listCompany(item.partyName);
          if (res.status === 1) {
            if(res.data.rows.length > 0){
              let compData = res.data.rows[0];
              item.signatureTypeOption = [];
              if (compData.sealUrl && compData.sealUrl !== '') {
                item.signatureTypeOption.push({
                  label: '公章',
                  value: 2
                })
              }
              if (compData.contractSealUrl && compData.contractSealUrl !== '') {
                item.signatureTypeOption.push({
                  label: '合同章',
                  value: 3
                })
              }
              if ((!compData.sealUrl || compData.sealUrl === '') && (!compData.contractSealUrl || compData.contractSealUrl === '')) {
                item.signatureTypeOption.push({
                  label: '法大大默认印章',
                  value: 1
                })
              }
            }
          }
        }
      }

      this.ordContractFadadaExpands = data.ordContractFadadaExpands;

      this.formData = data;

      if (type) {
        this.formData.contractNum = null;
      }
    },
    listCompany(name) {
      return new Promise((resolve, reject) => {
        resolve(
            $api.department.listCompany
                .GET({
                  params: {
                    name: name,
                    page: 1,
                    rows: 1000
                  }
                })
        )
      });
    },
    reset() {
      this.formData = {
        carShipId: null,
        carShipNum: null,
        carShipType: null,
        compName: null,
        contractName: null,
        contractNum: null,
        contractType: 41400618,
        docName: null,
        docUrl: null,
        firstPartyId: null,
        firstPartyName: null,
        firstPartyPhone: null,
        firstPartyType: null,
        beginTime: null,
        beginPlace: null,
        endPlace: null,
        goodsName: null,
        platformCompanyId: null,
        salesMan: null,
        salesManId: null,
        secondPartyId: null,
        secondPartyName: null,
        secondPartyPhone: null,
        secondPartyType: null,
        signType: null,
        isAcrosspage: 1,
        signPageNum: 1,
        signPositionsX: 0,
        signPositionsY: 0
      };
      this.isLoaded = false;
      this.ordContractFadadaExpands = [];
      this.signPlaceData = null;
      this.proData = {};
      this.clearTableV();
    },
    close() {
      this.$emit('close');
      this.reset();
    },
    handleUpload(file) {
      showLoading();
      this.file = file;
      let that = this;
      let reader = new FileReader();
      reader.onload = function (e) {
        that.imgUrl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    handleMaxSize(file) {
      hideLoading();
      this.$XModal.alert({
        message: '文件超过10M,请重新上传文件',
        status: "error",
      });
    },
    async imageToPdf(url, name) {
      let res = await $api.oss.request('imageToPdf', {
        targetPath: url,
        fileString: name
      });
      if (res.status === 1) {
        this.formData.docUrl = res.data.url;
        let arr = res.data.oldName.split('.');
        let name = '';
        arr.map((i, index) => {
          if (index < arr.length - 1) {
            name = name + i;
          }
        })
        this.formData.docName = name + '.pdf';
      } else {
        this.$Message.error(res.message ? res.message : "接口异常");
      }
    },
    async docToPdf(url, name) {
      let res = await $api.oss.request('docToPdf', {
        targetPath: url,
        fileString: name
      });
      if (res.status === 1) {
        this.formData.docUrl = res.data.url;
        let arr = res.data.oldName.split('.');
        let name = '';
        arr.map((i, index) => {
          if (index < arr.length - 1) {
            name = name + i;
          }
        })
        this.formData.docName = name + '.pdf';
      } else {
        this.$Message.error(res.message ? res.message : "接口异常");
      }
    },
    loadfile(res) {
      let self = this;
      hideLoading();
      if (res && res.status === 200 && res.data) {
        let fileType = res.data.oldName.split('.')[res.data.oldName.split(',').length];
        if (fileType === 'png' || fileType === 'jpg' || fileType === 'jpeg' || fileType === 'bmp') {
          this.imageToPdf(res.data.url, res.data.oldName);
        } else if (fileType === 'doc' || fileType === 'docx') {
          this.docToPdf(res.data.url, res.data.oldName);
        } else {
          let loadingTask = PDFJS.getDocument(res.data.url);
          loadingTask.promise.then(pdf => {
            pdf.getPage(1).then(function (page) {
              let viewport = page.getViewport(1);
              if (Math.round(viewport.width) === 595 && Math.round(viewport.height) === 842) {
                self.formData.docUrl = res.data.url;
                self.formData.docName = res.data.oldName;
              } else {
                self.$XModal.alert({
                  message: '该PDF不是标准A4格式，请重新上传',
                  status: "error",
                });
              }
            });
          });
        }
        this.clearTableV();
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    handleRemove() {
      this.formData.docUrl = null;
      this.formData.docName = null;
      this.signPlaceData = null;
    },
    selectComp(bool, index, row, item) {
      item.partyId = index.platformCompanyId;
      this.clearTableV();
      this.signPlaceData = null;
      item.signatureTypeOption = [];
      item.signatureType = null;
      if (row.sealUrl && row.sealUrl !== '') {
        item.signatureTypeOption.push({
          label: '公章',
          value: 2
        })
      }
      if (row.contractSealUrl && row.contractSealUrl !== '') {
        item.signatureTypeOption.push({
          label: '合同章',
          value: 3
        })
      }
      if ((!row.sealUrl || row.sealUrl === '') && (!row.contractSealUrl || row.contractSealUrl === '')) {
        item.signatureTypeOption.push({
          label: '法大大默认印章',
          value: 1
        })
      }
    }
  }
}

</script>
<style scoped>
.modal-container-edit {
  box-sizing: border-box;
  padding: 20px 60px;
  background: #F5F7F9;
}

.input-border {
  border: 1px solid #dcdfe6;
  width: 300px;
  height: 34px;
  border-radius: 4px;
  padding: 0 .6em;
}

.attach {
  width: 300px;
  height: 34px;
  display: flex;
  align-items: center;
}

.input-border a, .input-border span {
  cursor: pointer;
  display: inline-block;
  width: 100%;
  line-height: 34px;
}

.attach span {
  color: #438DF3;
  margin-left: 6px;
  font-size: 13px;
  font-family: Microsoft YaHei, sans-serif;
  font-weight: 400;
}

.footer {
  box-sizing: border-box;
  padding: 20px 0;
  display: flex;
  justify-content: flex-end;
}

.corp >>> .link-text {
  color: #2D8CF0;
  font-size: 14px;
  font-family: Roboto, sans-serif;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.block {
  background: #FFFFFF;
  box-shadow: 0px 0px 6px 0px rgba(211, 211, 211, 0.75);
  padding: 10px;
}

.radioGroup {
  display: flex;
  align-items: center;
}

.radioGroup >>> .ivu-radio {
  margin-right: 11px;
}

.add-group {
  display: flex;
  align-items: center;
}

.cell {
  display: flex;
  align-items: center;
}

.cell img {
  height: 15px;
  width: 15px;
}

.cell span {
  font-size: 14px;
  font-family: Microsoft YaHei, sans-serif;
  font-weight: 400;
  color: #438DF3;
  margin-left: 11px;
}

.add-block {
  width: 790px;
  min-height: 94px;
  position: relative;
  background: rgba(255, 255, 255, 0);
  border: 1px solid #E5E7EA;
  border-radius: 4px;
}

.add-block img {
  position: absolute;
  right: 0;
  top: 0;
  width: 24px;
  height: 24px;
}

.receive {
  position: absolute;
  top: 11px;
  left: -5px;
  min-width: 40px;
  height: 20px;
  background: #7E8799;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.receive span {
  font-size: 10px;
  font-family: PingFang SC, sans-serif;
  font-weight: 400;
  color: #FFFEFE;
  line-height: 20px;
}

.account-search-box {
  position: absolute;
  right: 30px;
  top: 8px;
  height: 36px;
  border: 1px solid #ccc;
  overflow: hidden;
}

.my-dropdown1 {
  height: 200px;
  overflow: auto;
  border-radius: 4px;
  background-color: #fff;
  border: 1px solid #dcdfe6;
}

.list-item1:hover {
  background-color: #f5f7fa;
}

.border-red {
  border-color: #f56c6c;
}

.signPlace {
  display: flex;
  align-items: center;
  color: #1A8CFE;
  cursor: pointer;
}

.signPlace img {
  margin-left: 18px;
  margin-right: 3px;
}

.historyModal >>> .vxe-modal--box .vxe-modal--body {
  background: transparent !important;
}

</style>